// Shared constants for appointment types components

// Standard height for interactive elements in ExpandableField
// This ensures smooth animations between Button, SchedulableItem, and SchedulingForm
export const EXPANDABLE_ITEM_HEIGHT = 40; // in pixels
